import { type Key, ToggleButton, ToggleButtonGroup } from '@heroui/react'

import { usePeriod } from '../payload/PeriodContext'
import { INSIGHTS_PERIODS } from '../payload/periods'

/**
 * The window, pinned: changing it and seeing what it does to the numbers has to
 * be one action, not one action and a scroll back up. The resolved range says
 * what "last 7 days" actually covers when the import lags.
 */
const PeriodPicker = () => {
  const { period, setPeriod, resolvedRange } = usePeriod()

  const select = (keys: Set<Key>): void => {
    const [key] = keys
    const next = INSIGHTS_PERIODS.find(p => p.key === key)
    if (next) setPeriod(next)
  }

  return (
    <div className="bg-background sticky top-0 z-10 grid gap-1 py-3">
      <div className="flex flex-wrap items-center gap-3">
        <span className="text-muted text-[0.6875rem] font-semibold tracking-wider uppercase">
          Showing
        </span>
        <ToggleButtonGroup
          aria-label="Period"
          selectionMode="single"
          disallowEmptySelection
          size="sm"
          selectedKeys={new Set<Key>([period.key])}
          onSelectionChange={select}
        >
          {INSIGHTS_PERIODS.map((p, i) => (
            <ToggleButton key={p.key} id={p.key}>
              {i > 0 && <ToggleButtonGroup.Separator />}
              {p.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </div>
      <p className="text-muted text-xs">
        {resolvedRange}
        <span className="hidden sm:inline">
          {' · every figure on the page follows this window'}
        </span>
      </p>
    </div>
  )
}

export default PeriodPicker
